module.exports = __webpack_public_path__ + "img/right-0.045c7c5e.jpg";